import * as Utility from "../Common/Base";
import _debounce from 'lodash/debounce';

export class TextFieldService {
    // store debounced functions per-field so hooks aren't used in services
    static debounceFns: { [key: string]: any } = {};
    static handleTextField = async (e, data, secId, quesId, prevState, updateLocalState, keyUp, configType, subConfigType) => {
        const { name, value } = e.target ? e.target : e;

        let { DynamicQuestions, client_form, error, hasError } = prevState;
        const key = name || (data && data.question) || 'global_textfield';
        if (!TextFieldService.debounceFns[key]) {
            TextFieldService.debounceFns[key] = _debounce((eventValue, prevState, dataParam, configTypeParam, subConfigTypeParam, updateLocalStateParam, keyUpParam) => {
                try {
                    keyUpParam && keyUpParam(eventValue, prevState, dataParam, configTypeParam, subConfigTypeParam, updateLocalStateParam);
                } catch (err) {
                    // eslint-disable-next-line no-console
                    console.error('TextFieldService debounced keyUp error', err);
                }
            }, 1000);
        }
        const debounceFn = TextFieldService.debounceFns[key];

        let updatedDynamicQuestions = DynamicQuestions;
        let updatedClientForm = { ...client_form };
        let updatedError = { ...error };

        updatedDynamicQuestions = updatedDynamicQuestions.map((question) => {
            return {
                ...question,
                questions: question.questions.map((ques) => {
                    if (ques.question === name) {
                        return {
                            ...ques,
                            answer: value
                        };
                    }
                    return ques;
                })
            };
        });

        let ErrorData = TextFieldService.ValidateField(name, value, data, client_form, updatedError, hasError);

        updatedClientForm[name] = value;
        await updateLocalState({
            ...ErrorData,
            DynamicQuestions: updatedDynamicQuestions,
            client_form: updatedClientForm
        });
        if (data?.is_primary_key) {
        const eventValue = { name: name, value: value }
        debounceFn(eventValue, prevState, data, configType, subConfigType, updateLocalState, keyUp);
         }
    };

    static ValidateField(name, value, data, client_form, updatedError, hasError) {
        const val2 = data.validation2 || '';
        const error_msg = data.error_msg || '';
        const error_msg2 = data.error_msg2 || '';
        const parent_question = data?.parent_question || '';
        const is_re_type = data.re_type || '';
        const is_exact = data?.exact_match || '';
        const currQues = name.replaceAll('_', ' ');

        // Compare Parent Question's Answer Type with Child Question's Answer Type
        let match_ans_err = '';
        if (is_re_type === 'yes') {
            match_ans_err = client_form[`Re-Type ${name}`] && value !== client_form[`Re-Type ${name}`] ? `${currQues} and Re-Type ${currQues} must match` : '';
        }

        data.answer = value;

        // Parent Question Validation
        if (parent_question) {
            const isEqualAnswer = client_form[parent_question] === value;
            updatedError[name] = isEqualAnswer ? '' : error_msg;
            hasError = !isEqualAnswer;
        } else {
            // Validation based on defined validation at tool
            const regex = Utility.regexHandler(val2, data.spl_characters, data.validation3, data.validation4, value, is_exact);
            const textRegex = new RegExp(regex);
            updatedError[name] = textRegex.test(value) ? match_ans_err : error_msg ? `${data.question}: ${error_msg}` : error_msg2;
            hasError = data.required === 'no' ? false : !textRegex.test(value);
        }
        return {
            error: updatedError,
            hasError: hasError
        }
    }


}

export default TextFieldService;
